import { WorkspaceDetails, WorkspaceDetailsBase } from "../../types/workspace";
import { BillingTransferRequest } from "../billing/transfer-request.dto";
import { WorkspaceDto } from "../workspace/workspace.dto";
import { WorkspaceAssignmentDto } from "./workspace-assignment.dto";
import { OrganizationWorkspaceAssignmentDto } from "./workspace-organization-assignment.dto";
import { WorkspacePendingInvite } from "./workspace-pending-invite.dto";

export class WorkspaceDetailsDto {
    static deserialize(dto: WorkspaceDetailsDto): WorkspaceDetails {
        return {
            workspace: WorkspaceDto.deserialize(
                dto.workspace,
            ) as WorkspaceDetails["workspace"],
            assignments: dto.assignments.map(
                WorkspaceAssignmentDto.deserialize,
            ),
            pendingInvites: dto.pendingInvites,
            organizationAssignments: dto.organizationAssignments.map(
                OrganizationWorkspaceAssignmentDto.deserialize,
            ),
            pendingTransferRequests: dto.pendingTransferRequests,
        };
    }

    workspace: WorkspaceDto;
    assignments: WorkspaceAssignmentDto[];
    pendingInvites: WorkspacePendingInvite[];
    organizationAssignments: OrganizationWorkspaceAssignmentDto[];
    pendingTransferRequests: BillingTransferRequest[];

    constructor(workspaceDetails: WorkspaceDetailsBase) {
        this.workspace = new WorkspaceDto(workspaceDetails.workspace);
        this.assignments = workspaceDetails.assignments.map(
            (assignment) => new WorkspaceAssignmentDto(assignment),
        );

        this.organizationAssignments =
            workspaceDetails.organizationAssignments.map(
                (assignment) =>
                    new OrganizationWorkspaceAssignmentDto(assignment),
            );
        this.pendingInvites = workspaceDetails.pendingInvites;
        this.pendingTransferRequests = workspaceDetails.pendingTransferRequests;
    }
}
